import React from 'react';
import './YoungProfRsvpAnalytics.css';

function outcomeEntries(obj) {
  if (!obj) return [];
  return Object.entries(obj)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count);
}

export default function YoungProfRsvpAnalytics({ analytics }) {
  if (!analytics) return null;

  const {
    total = 0,
    attending_count: attendingCount = 0,
    not_attending_count: notAttendingCount = 0,
    no_answer_count: noAnswerCount = 0,
    attendance_rate: attendanceRate = 0,
    outcome_breakdown: outcomeBreakdown = {},
  } = analytics;

  const outcomes = outcomeEntries(outcomeBreakdown);

  return (
    <div className="card young-prof-rsvp-analytics">
      <h3>Breakfast Headcount — Saturday, 30 May @ 10 AM</h3>

      <div className="stats-grid">
        <div className="stat ypf-headcount" title="Kitchen — prepare food and water for this many people">
          <div className="stat-value">{attendingCount}</div>
          <div className="stat-label">Attending (Kitchen Headcount)</div>
        </div>
        <div className="stat">
          <div className="stat-value">{notAttendingCount}</div>
          <div className="stat-label">Not Attending</div>
        </div>
        <div className="stat">
          <div className="stat-value">{noAnswerCount}</div>
          <div className="stat-label">No Answer</div>
        </div>
        <div className="stat">
          <div className="stat-value">{attendanceRate.toFixed(1)}%</div>
          <div className="stat-label">Confirm Rate</div>
        </div>
      </div>

      <div className="ypf-section">
        <h4>Total Calls: {total}</h4>
      </div>

      <div className="ypf-section">
        <h4>Call Outcomes</h4>
        <div className="ypf-outcome-badges">
          {outcomes.length === 0 ? (
            <span style={{ color: '#666', fontSize: '0.85rem' }}>No data yet.</span>
          ) : (
            outcomes.map((entry) => (
              <span key={entry.name} className="badge badge-neutral">
                {entry.name.replace('_', ' ')}: {entry.count}
              </span>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
